import { createSlice } from '@reduxjs/toolkit'

export const loadingProgressSlice = createSlice({
    name: 'loadingProgress',
    initialState: { loadedItems: 0, totalItems: 0 },
    reducers: {
        resetLoadingProgress: () => ({ loadedItems: 0, totalItems: 0 }),
        setLoadingProgress: (_state, action) => action.payload,
    },
})

export const { resetLoadingProgress, setLoadingProgress } = loadingProgressSlice.actions
